import { useEffect, useState } from 'react'
import { chatApi } from '@carrent/api'
import { messageTimeLabel } from '@carrent/domain'
import { Icon, PageHeader } from '@carrent/ui'

/**
 * «Сохранённое» — личные важные моменты.
 *
 * Плоский список без диалогового контекста: сюда приходят
 * перечитать конкретное («код от склада», «регламент возврата»),
 * а не листать переписку.
 */
export default function SavedPage() {
  const [items, setItems] = useState(null)
  const [error, setError] = useState('')

  const load = () => {
    setError('')
    chatApi
      .saved()
      .then(({ data }) => setItems(data.data.items))
      .catch((e) =>
        setError(e?.response?.data?.message || 'Не удалось загрузить'))
  }

  useEffect(load, [])

  const unsave = async (messageId) => {
    await chatApi.unsave(messageId)
    setItems((cur) => cur.filter((s) => s.message_id !== messageId))
  }

  return (
    <div className="p-page flex-col gap">
      <PageHeader title="Сохранённое" />

      {items === null && !error && <span className="spinner" aria-label="Загрузка" />}

      {error && (
        <div className="chat-list-screen__state">
          <p className="text-muted">{error}</p>
          <button type="button" className="btn btn--secondary" onClick={load}>
            Повторить
          </button>
        </div>
      )}

      {items?.length === 0 && (
        <div className="chat-list-screen__state">
          <Icon name="bookmark" size={36} />
          <p className="text-muted">
            Нажмите «Сохранить» на сообщении — оно останется здесь.
          </p>
        </div>
      )}

      {items?.map((s) => (
        <div key={s.id} className="card saved-item">
          <div className="saved-item__body">
            {s.message?.deleted ? (
              <span className="text-muted">Сообщение удалено</span>
            ) : (
              s.message?.body || 'Вложение'
            )}
            <div className="saved-item__meta text-muted">
              {s.message?.sender?.full_name}
              {' · '}
              {messageTimeLabel(s.message?.created_at)}
            </div>
          </div>
          <button
            type="button"
            className="saved-item__remove"
            aria-label="Убрать из сохранённого"
            onClick={() => unsave(s.message_id)}
          >
            <Icon name="close" size={18} />
          </button>
        </div>
      ))}
    </div>
  )
}
